import { AuroraMesh, buttonClasses, Chip, OrbVisualizer } from '@qi/ui';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Camera, Check, Lock, Zap } from 'lucide-react';

export const Route = createFileRoute('/_funnel/start/')({
  component: FunnelLanding,
});

const PRELUDE = [
  { icon: <Zap size={12} strokeWidth={2} />, label: '60-second scan' },
  { icon: <Camera size={12} strokeWidth={2} />, label: 'Webcam + mic' },
  { icon: <Lock size={12} strokeWidth={2} />, label: 'Nothing recorded' },
  { icon: <Check size={12} strokeWidth={2} />, label: 'Free to start' },
] as const;

function FunnelLanding() {
  return (
    <section
      aria-labelledby="funnel-hero-heading"
      className="relative overflow-hidden px-6 pb-20 pt-12 md:pt-20"
    >
      <AuroraMesh intensity="standard" position="top" />
      <div className="relative mx-auto flex max-w-2xl flex-col items-center gap-8 text-center">
        <div className="relative">
          <div
            aria-hidden="true"
            className="absolute inset-0 -z-10 rounded-full"
            style={{ boxShadow: 'var(--glow-aurora)' }}
          />
          <OrbVisualizer size={200} rings={4} />
        </div>

        <h1
          id="funnel-hero-heading"
          className="text-balance font-display text-4xl leading-[1.05] text-ink-0 md:text-5xl"
        >
          See how your nervous system is really doing.
        </h1>
        <p className="max-w-xl text-pretty text-lg text-ink-1">
          A quick scan reads how your body is holding tension and energy right now — then tunes the
          exact frequencies it needs. Just your webcam and mic.{' '}
          <span className="text-aurora">No app to install.</span>
        </p>

        <div className="flex flex-wrap items-center justify-center gap-2">
          {PRELUDE.map((item) => (
            <Chip key={item.label} tone="aurora">
              <span className="inline-flex items-center gap-1.5 text-aurora">
                {item.icon}
                <span className="text-ink-1">{item.label}</span>
              </span>
            </Chip>
          ))}
        </div>

        <Link
          to="/start/goal"
          className={`${buttonClasses({ variant: 'resonance', size: 'lg' })} group`}
        >
          <span>Start my free scan</span>
          <span
            aria-hidden="true"
            className="transition-transform duration-200 group-hover:translate-x-0.5"
          >
            →
          </span>
        </Link>

        <p className="inline-flex items-center gap-2 text-sm text-ink-2">
          <Lock size={13} strokeWidth={2} className="shrink-0 text-jade" aria-hidden="true" />
          Everything stays in your browser — nothing is recorded or uploaded.
        </p>
      </div>
    </section>
  );
}
